import RaicheSignUpContainer from "../../../raicheComponents/raicheSignUpContainer/RaicheSignUpContainer";
import RaikoInput from "../../../raikoComponents/raikoInput/baseRaikoInput/RaikoInput";
import {useState} from "react";
import {RaikoGridTwoColumn} from "@moeindal/base-raiko-panel-components";
import {RaikoLabel} from "@moeindal/base-raiko-panel-components"

export default function LegalPerson() {
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("")
    return (
        <RaicheSignUpContainer>

            <RaikoLabel text={"لطفا اطلاعات کسب و کار خود را وارد کنید"}/>
            <RaikoGridTwoColumn>
                <RaikoInput
                    value={name}
                    title={"نام"}
                    placeHolder={"نام خود را وارد نمایید..."}
                />
                <RaikoInput
                    value={lastName}
                    title={"نام خانوادگی"}
                    placeHolder={"نام خانوادگی خود را وارد نمایید..."}
                />
            </RaikoGridTwoColumn>
        </RaicheSignUpContainer>


    )
}